export default class DataService {

    baseUrl = `https://portal.taxidigital.net/WsTaxidigital/Ws.asmx`;
    pdaUrl = `https://portal.taxidigital.net/WsTaxidigital/WsPDA.asmx`;
    terminalUrl = `https://portal.taxidigital.net/WsTaxidigital/WsTerminal.asmx`;
    cartaoUrl = `https://portal.taxidigital.net/WsTaxidigital/WsCartaoCredito.asmx`;

    constructor(){
        this.baseUrl = `${window.location.protocol}//portal.taxidigital.net/WsTaxidigital/Ws.asmx`;
        this.pdaUrl = `${window.location.protocol}//portal.taxidigital.net/WsTaxidigital/WsPDA.asmx`;
        this.cartaoUrl = `${window.location.protocol}//portal.taxidigital.net/WsTaxidigital/WsCartaoCredito.asmx`;
        this.terminalUrl = `${window.location.protocol}//portal.taxidigital.net/WsTaxidigital/WsTerminal.asmx`;
    };

    async GetDadoPreLogin(dados, onSuccess, onFail) {        
        await this.postData("GetDadoPreLogin", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetListaEstabelecimento(dados, onSuccess, onFail) {        
        await this.postData("GetListaEstabelecimento", dados, this.pdaUrl, "ObEstabelecimento", onSuccess, onFail);
    }

    async GetFiltroAcessoPessoa(dados, onSuccess, onFail) {        
        await this.postData("GetFiltroAcessoPessoa", dados, this.pdaUrl, "ObFiltroAcessoPessoa", onSuccess, onFail);
    }

    async GetListaRastreamento(dados, onSuccess, onFail) {        
        await this.postData("GetListaRastreamento", dados, this.pdaUrl, "ObListaRastreamento", onSuccess, onFail);
    }

    async GetListaHistoricoPA(dados, onSuccess, onFail) {        
        await this.postData("GetListaHistoricoPA", dados, this.pdaUrl, "ObListaHistoricoPA", onSuccess, onFail);
    }

    async Login(dados, onSuccess, onFail) {
        await this.postData("Login", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetDadoPerfil(dados, onSuccess, onFail) {
        await this.postData("GetDadoPerfil", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetSaldo(dados, onSuccess, onFail) {
        await this.postData("GetSaldo", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetCarteiraTransferenciaConta(dados, onSuccess, onFail) {
        await this.postData("GetCarteiraTransferenciaConta", dados, this.pdaUrl, "ObCarteiraTransferenciaConta", onSuccess, onFail);
    }

    async TransfereSaldo(dados, onSuccess, onFail) {
        await this.postData("TransfereSaldo", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetCarteiraMovimento(dados, onSuccess, onFail) {
        await this.postData("GetCarteiraMovimento", dados, this.pdaUrl, "ObCarteiraMovimento", onSuccess, onFail);
    }

    async GetCarteiraMovimentoDet(dados, onSuccess, onFail) {
        await this.postData("GetCarteiraMovimentoDet", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetTransferenciaTaxa(dados, onSuccess, onFail) {
        await this.postData("GetTransferenciaTaxa", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetBancoCadastro(dados, onSuccess, onFail) {
        await this.postData("GetBancoCadastro", dados, this.pdaUrl, "ObBancoCadastro", onSuccess, onFail);
    }

    async SalvaContaBancaria(dados, onSuccess, onFail) {
        await this.postData("SalvaContaBancaria", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetContaBancaria(dados, onSuccess, onFail) {
        await this.postData("GetContaBancaria", dados, this.pdaUrl, "ObContaBancaria", onSuccess, onFail);
    }

    async GetCarteiraTitulo(dados, onSuccess, onFail) {
        await this.postData("GetCarteiraTitulo", dados, this.pdaUrl, "ObCarteiraTitulo", onSuccess, onFail);
    }

    async ListaCartaoCreditoBandeira(dados, onSuccess, onFail) {
        await this.postData("ListaCartaoCreditoBandeira", dados, this.cartaoUrl, "ObListaCartaoCreditoBandeira", onSuccess, onFail);
    }

    async ListaCartaoCredito(dados, onSuccess, onFail) {
        await this.postData("ListaCartaoCredito", dados, this.cartaoUrl, "ObListaCartaoCredito", onSuccess, onFail);
    }

    async SalvaCartaoCredito(dados, onSuccess, onFail) {
        await this.postData("Registra", dados, this.cartaoUrl, "ObStatus", onSuccess, onFail);
    }

    async ApagarCartaoCredito(dados, onSuccess, onFail) {
        await this.postData("Apaga", dados, this.cartaoUrl, "ObStatus", onSuccess, onFail);
    }

    async ConfirmaCartao(dados, onSuccess, onFail) {
        await this.postData("ConfirmaCartao", dados, this.cartaoUrl, "ObStatus", onSuccess, onFail);
    }

    async GetListaCarteiraDespesa(dados, onSuccess, onFail) {
        await this.postData("GetListaCarteiraDespesa", dados, this.pdaUrl, "ObListaCarteiraDespesa", onSuccess, onFail);
    }

    async EmitirDespesaAvulsa(dados, onSuccess, onFail) {
        await this.postData("EmitirDespesaAvulsa", dados, this.pdaUrl, "", onSuccess, onFail);
    }
    
    async GetListaTipoBaixaTituloAPagar(dados, onSuccess, onFail) {
        await this.postData("GetListaTipoBaixaTituloAPagar", dados, this.pdaUrl, "ObListaTipoBaixaTituloAPagar", onSuccess, onFail);
    }
    
    async BaixarTituloAPagar(dados, onSuccess, onFail) {
        await this.postData("BaixarTituloAPagar", dados, this.pdaUrl, "", onSuccess, onFail);
    }

    async GetListaRadioDocumentos(dados, onSuccess, onFail) {        
        await this.postData("GetListaRadioDocumentos", dados, this.baseUrl, "ObListaRadioDocumentos", onSuccess, onFail);
    }

    async DownloadRadioDocumento(dados, onSuccess, onFail) {        
        await this.getArquivo("DownloadRadioDocumento", dados, this.baseUrl, "ObListaRadioDocumentos", onSuccess, onFail);
    }    

    async ListaChamadoPwa(dados, onSuccess, onFail) {        
        await this.postData("ListaChamadoPwa", dados, this.terminalUrl, "chamado", onSuccess, onFail);
    }

    async ListaStatus(dados, onSuccess, onFail) {        
        await this.postData("ListaStatus", dados, this.terminalUrl, "obStatus", onSuccess, onFail);
    }

    async ListaTotaisChamadoPwa(dados, onSuccess, onFail) {        
        await this.postData("ListaTotaisChamadoPwa", dados, this.terminalUrl, "totais", onSuccess, onFail);
    }

    async ListaChamadoResumoPwa(dados, onSuccess, onFail) {        
        await this.postData("ListaChamadoResumoPwa", dados, this.terminalUrl, "formaDePagamento", onSuccess, onFail);
    }

    buildSoapRequest(action, dados, withHeader = true){
        var sr = "";

        if(withHeader){
            sr =
            '<?xml version="1.0" encoding="utf-8"?>' +
            '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' +
            'xmlns:xsd="http://www.w3.org/2001/XMLSchema" ' +
            'xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
            '<soap:Body><' + action + ' xmlns="http://tempuri.org/">' +
            '<dsXML><![CDATA[<data>';
        }else{
            sr = "<data>";
        }

        for (var key in dados) {
            sr += '<' + key + '>' + dados[key] + '</' + key + '>';
        }

        if(withHeader){
            sr += '</data>]]></dsXML></' + action + '>' +
            '</soap:Body></soap:Envelope>';
        }else{
            sr += '</data>';
        }

        return sr;
    }

    getArquivo(action, dados, urlRequest, fieldArray, onSuccess, onFail) {
        var param = this.buildSoapRequest(action, dados, false);

        var urlDownload = `${urlRequest}/${action}?dsXML=${param}`;

        try {
            var link = document.getElementById("downloadLink");
            if(link == null){
                link = document.createElement("a");
                link.id = "downloadLink";
                // link.setAttribute("target", "_blank");
            }
            
            link.href = urlDownload;

            document.querySelector("body").appendChild(link);
            link.click();

            onSuccess();
        } catch (error) {
            onFail(error);
        }
    }

    // getArquivo(action, dados, urlRequest, fieldArray, onSuccess, onFail) {
    //     var xmlhttp = new XMLHttpRequest();
    //     xmlhttp.responseType = 'blob';
    //     xmlhttp.open('POST', urlRequest, true);

    //     var sr = this.buildSoapRequest(action, dados);

    //     xmlhttp.onload = function() {
    //         try{
    //             saveAs(xmlhttp.response, dados["dsNomeArquivo"]);
    //             onSuccess();
    //         }catch(ex){
    //             onFail(ex);
    //         }
    //     }

    //     // Send the POST request
    //     xmlhttp.setRequestHeader('Access-Control-Allow-Origin', '*');
    //     xmlhttp.setRequestHeader("SOAPAction", "http://tempuri.org/" + action);
    //     xmlhttp.setRequestHeader("Content-Type", "text/xml; charset=utf-8");
    //     xmlhttp.withCredentials = false;
    //     xmlhttp.send(sr);
    // }

    postData(action, dados, urlRequest, fieldArray, onSuccess, onFail) {
        
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.open('POST', urlRequest, true);

        var sr = this.buildSoapRequest(action, dados);

        xmlhttp.onreadystatechange = function () {

            if (xmlhttp.readyState === 4) {

                var XMLParser = require('react-xml-parser');
                var xml = new XMLParser().parseFromString(xmlhttp.responseText);

                // console.log(xmlhttp.responseText);

                if (xml != undefined) {
                    var result = xml.getElementsByTagName(action + 'Result')[0];
                   
                    var retorno = [];
                    
                    if (result) {
                     
                        for (var i = 0; i < result.children.length; i++) {

                            var node = result.children[i];
                            
                            if (node.children.length > 0) {

                                if (fieldArray == "") {

                                    var data = [];
                                    
                                    for (var y = 0; y < node.children.length; y++) {

                                        var lastNode = node.children[y];

                                        if (lastNode.children.length === 0) {

                                            data[lastNode["name"]] = lastNode["value"];

                                        }

                                    }
                                    
                                    retorno.push(data);

                                } else {

                                    var array = node.getElementsByTagName(fieldArray);
                                    
                                    for (var y = 0; y < array.length; y++) {
                                        

                                        var lastNode = array[y];
                                        // console.log(lastNode);
                                        if (lastNode.children[0].name != lastNode.name &&
                                            lastNode.children[0].name != action + 'Result') {

                                            var data = [];

                                            for (var x = 0; x < lastNode.children.length; x++) {

                                                var lastNodeArray = lastNode.children[x];
                                                //console.log(lastNodeArray);
                                                if (lastNodeArray.children.length === 0) {

                                                    data[lastNodeArray["name"]] = lastNodeArray["value"];
                                                }

                                            }

                                            retorno.push(data);
                                        }
                                    }
                                }

                            } else {
                        
                                retorno[node["name"]] = node["value"];

                            }
                        }                        

                        if (retorno[0] && retorno[0].length == 0 && fieldArray == "") {
                            retorno.splice(0, 1);
                            delete retorno[0];
                        }

                        // console.log(retorno);
                        onSuccess(retorno);

                    } else {

                        var resultError = xml.getElementsByTagName('faultstring')[0];

                        var stringError = "Erro interno do servidor";

                        if (resultError && resultError.value) {
                            stringError = resultError.value;
                        }

                        onFail(stringError, dados);

                    }

                } else {

                    var stringError = "Erro interno do servidor";
                    onFail(stringError, dados);
                }


            }
        }

        // Send the POST request
        xmlhttp.setRequestHeader('Access-Control-Allow-Origin', '*');
        xmlhttp.setRequestHeader("SOAPAction", "http://tempuri.org/" + action);
        xmlhttp.setRequestHeader("Content-Type", "text/xml; charset=utf-8");
        xmlhttp.withCredentials = false;
        xmlhttp.send(sr);
    }
}


// WEBPACK FOOTER //
// ./src/Components/Data.js